import { Controller } from "@hotwired/stimulus"
import TableFrameNavigator from "../../utils/table_frame_navigator"
import TableQueryState from "../../utils/table_query_state"

// Connects to data-controller="realities--quick-filters"
export default class extends Controller {
  static outlets = ["realities--filter"]

  connect() {
    this.tableNavigator = new TableFrameNavigator({ frameId: "realities_list", tableKey: "realities" })
    this.#initializeQuickFilters()
  }

  disconnect() {
    this.tableNavigator?.disconnect()
  }

  applyQuickFilter(event) {
    const currentQueryParams = new URLSearchParams(window.location.search)
    let newParams = new URLSearchParams()
    const filterController = this.hasRealitiesFilterOutlet ? this.realitiesFilterOutlet : null

    if (event.target.value !== "all" && !currentQueryParams.has("quickFilter")) {
      this.element.dataset.queryParams = currentQueryParams.toString()
      filterController?.removeValuesFromFilters()
    }
    if (event.target.value !== "all") {
      newParams.set("quickFilter", event.target.value)
    }

    switch (event.target.value) {
      case "all":
        newParams = new URLSearchParams(this.element.dataset.queryParams || "")
        break
      default:
        // All quick filters are handled server-side via the quickFilter param
        break
    }
    this.#constructUrlAndSendRequest(newParams)
  }

  #constructUrlAndSendRequest(params) {
    this.tableNavigator.navigate(new TableQueryState(params), {
      history: "push",
      reason: "filter",
      preserveScroll: { x: true, y: false }
    })
  }

  #initializeQuickFilters() {
    const currentQueryParams = new URLSearchParams(window.location.search)
    if (currentQueryParams.has("quickFilter")) {
      const quickFilterId = `quick_filter_${currentQueryParams.get("quickFilter")}`
      const element = document.getElementById(quickFilterId)
      if (element) {
        element.checked = true
      }
    } else {
      const allElement = document.getElementById("quick_filter_all")
      if (allElement) {
        allElement.checked = true
      }
    }
  }
}
